import AxiosInstance from '@/api/axios';
import { useEffect, useState } from 'react';

interface IHubspotCompanyOption {
  id: string;
  name: string;
  domain: string;
}

const useHubspotCompanyOptions = (ids: string[]) => {
  const [options, setOptions] = useState<IHubspotCompanyOption[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!ids.length) return;
    const fetchDetails = async () => {
      setLoading(true);
      try {
        const res = await AxiosInstance.get(`/hubspot/companies/ids`, {
          params: { ids: ids.join(',') },
        });
        setOptions(res.data.data ?? []);
      } catch (err) {
        console.error('Failed to fetch company details', err);
        setOptions(ids.map((id) => ({ id, name: id, domain: '' })));
      } finally {
        setLoading(false);
      }
    };
    fetchDetails();
  }, [ids.join(',')]);

  return { options, loading };
};

export default useHubspotCompanyOptions;
